'use client';

import * as React from 'react';

import { slugify } from '@/lib/shared/utils/slugify';
import Link from 'next/link';
import { cn } from '@/lib/shared/ui';
import { tagName } from '@/lib/shared/utils/cookbook';
type Props = {
  tag: string;
  current?: boolean | null;
};

const colors = [
  'border-l-accent',
  'border-l-accent-two',
  'border-l-accent-three',
  'border-l-accent-four',
  'border-l-[#ffc73b]',
  'border-l-[#ff851c]',
  'border-l-[#ff851c]',
  'border-l-[#e31c24]',
];

/**
 Pick a randomized color name for a tag string, returning the same color each
 time for the same tag.
 */
function colorForTag(tag: string): string {
  let hash = 0;
  for (let i = 0; i < tag.length; i++) {
    hash = ((hash << 1) - hash + tag.charCodeAt(i)) << 0;
  }
  return colors[Math.abs(hash) % colors.length];
}

export default function Tag(props: Props) {
  const { tag, current } = props;
  const className = colorForTag(tag);
  const href = `/cookbook/tag/${slugify(tag)}`;

  return (
    <Link href={current ? '' : href}>
      <div
        className={cn(
          'p-3 py-2 text-sm font-bold bg-foreground/10 hover:bg-foreground/[.15] rounded border-l-4',
          className,
        )}
      >
        {tagName(tag)}
      </div>
    </Link>
  );
}
